import { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    const saved = sessionStorage.getItem('vcm_user');
    return saved ? JSON.parse(saved) : null;
  });
  const [token, setToken] = useState(() => sessionStorage.getItem('vcm_token'));

  const login = (tokenVal, userData) => {
    sessionStorage.setItem('vcm_token', tokenVal);
    sessionStorage.setItem('vcm_user', JSON.stringify(userData));
    setToken(tokenVal);
    setUser(userData);
  };

  const logout = () => {
    sessionStorage.removeItem('vcm_token');
    sessionStorage.removeItem('vcm_user');
    setToken(null);
    setUser(null);
  };

  const isAdmin = user?.role === 'admin';
  const isSupervisor = user?.role === 'supervisor';
  const isAgent = user?.role === 'agent';

  return (
    <AuthContext.Provider value={{ user, token, login, logout, isAdmin, isSupervisor, isAgent, isAuthenticated: !!token }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
